import React, { Component } from 'react';
import {
  Modal,
  Layout,
  Row,
  Col,
  Steps,
  Button,
  message,
  Icon,
  Input,
  Form,
} from 'antd';
import InputMask from 'react-input-mask';
import './styles.css';
import RateComponent from '../../components/RateComponent';
import btnInsta from '../../images/btnInstagram.png';
import btnZap from '../../images/btnWhatsApp.png';

import Service from './Service';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getUserData,
  getDataUserCompany,
  getModalTrue,
} from '../../redux/actions';
import { obterLogo } from '../../components/ModalLogomarca/services';
import { consultarTipoExibicao } from '../../components/QuestionsClient/services';
import { validaEmail } from '../../utils';

const { Content } = Layout;
const { TextArea } = Input;
const { Step } = Steps;
const arr = new Array('', '', '', '', '', '', '', '', '', '', '');

class QuizSteps extends Component {
  constructor(props) {
    super(props);

    this.state = {
      current: 0,
      indice_blue: null,
      showButton: true,
      critica: '',
      elogio: '',
      nome: '',
      celular: '',
      email: '',
      arrResponse: [],
      subPerguntas: [],
      temRedeSocial: false,
      exibirGoogle: false,
      exibirTrip: false,
      exibirInsta: false,
      exibirWhatsApp: false,
      urlGoogle: '',
      urlTrip: '',
      urlInsta: '',
      urlWhats: '',
      textoInsta: '',
      textoZap: '',
      exibirRedes: false,
      rateValue: [],
      checkSubPerguntas: [],
      idEmpresa: null,
      idFilial: null,
      logoCliente: '',
      tipoExibicaoQuesito: 1,
      identificacaoObrigatoria: false,
      redirecionamentoGoogle: false,
      // Ja vem preenchido pela tela anterior (Quiz), via Redux. Isso importa
      // no PRIMEIRO render: questionsFilial chega instantaneo do Redux e a
      // pergunta do NPS monta o nome da filial a partir dele - se este valor
      // comecasse sempre false e so fosse buscado depois, o nome aparecia e
      // sumia (a "piscada") justamente nas unidades marcadas como sem nome.
      unidadeSemNome:
        (props.questionsFilial && props.questionsFilial.unidadeSemNome) || false,
      respostaUnica: false,
      planoEmpresa: 0,
      showModal: false,
      modalMessage: 'Abrindo o Google em 5...',
      redes: []
    };

    this.service = new Service();
  }

  async componentDidMount() {
    const { idEmpresa, idFilial } = this.props.match.params;
    if (idEmpresa && idFilial) {
      this.setState({
        idEmpresa: Number(idEmpresa),
        idFilial: Number(idFilial),
      });

      // So busca se a tela anterior nao tiver passado o valor (acesso direto
      // a /steps, sem passar pelo Quiz). No fluxo normal isso economiza uma
      // ida a rede - e evita reescrever o valor que ja esta certo.
      const jaSabe =
        this.props.questionsFilial &&
        this.props.questionsFilial.unidadeSemNome !== undefined;

      if (!jaSabe) {
        const unidadeSemNome = await this.service.getUnidadeSemNome(idFilial);
        this.setState({ unidadeSemNome });
      }

      const url = window.location.href;

      let quiosque = undefined;

      if (url.includes('quiosque')) {
        quiosque = url;
      }

      const [
        _changeFilial,
        _questionsFilial,
        _logo,
        _tipoExibicao,
        _identificacaoObrigatoria,
        resultRedes,
      ] = await Promise.all([
        this.handleChangeFilial(),
        this.getQuestionsFilial(),
        this.carregarLogo(Number(idEmpresa), Number(idFilial)),
        this.carregarTipoExibicao(Number(idEmpresa)),
        this.carregarIdentificacaoObrigatoria(Number(idFilial)),
        this.service.listarRedeSocialPorFilial(idFilial),
      ]);

      const redes = resultRedes.object;

      let google = false;
      let googleUrl = '';
      let trip = false;
      let tripUrl = '';
      let insta = false;
      let instaUrl = '';
      let zap = false;
      let zpUrl = '';
      let exibirRedes = false;
      let txtCritica = '';
      let txtElogio = '';
      let txtInsta = '';
      let txtZap = '';

      const googleLogic = () => {
        const goo = redes.filter(x => x.tipo === 'Google');

        const nota = this.state.indice_blue;

        const critica = this.state.arrResponse.filter(x => x.idPergunta === 87);

        if (!goo || goo.length === 0) {
          return false;
        }

        googleUrl = goo[0].urlAcesso;

        if (this.state.redirecionamentoGoogle) {
          if (
            goo[0].exibirParaCriticas &&
            critica &&
            critica.length > 0 &&
            critica[0].valorChar
          ) {
            return false;
          }

          if (goo[0].exibirApenasPromotores && nota >= 9) {
            return true;
          }

          if (goo[0].exibirPromotoresNeutros && nota >= 7) {
            return true;
          }

          if (goo[0].exibirParaTodas) {
            return true;
          }

          if (goo[0].exibirParaCriticas) {
            return false;
          }
        }

        return true;
      };

      if (!quiosque) {
        if (redes && redes.length > 0) {
          exibirRedes = true;

          google = googleLogic();

          const trp = redes.filter(x => x.tipo === 'TripAdvisor');

          if (trp && trp.length > 0) {
            trip = true;
          } else {
            trip = false;
          }

          const ig = redes.filter(x => x.tipo === 'Instagram');
          if (ig && ig.length > 0) {
            insta = true;
            instaUrl = ig[0].urlAcesso;
            txtInsta = ig[0].texto;
          } else {
            insta = false;
          }

          const zp = redes.filter(x => x.tipo === 'WhatsApp');

          if (zp && zp.length > 0) {
            zap = true;
            zpUrl = zp[0].urlAcesso;
            txtZap = zp[0].texto;
          } else {
            zap = false;
          }
        }
      }

      this.setState({
        loading: false,
        temRedeSocial: exibirRedes,
        exibirGoogle: google,
        exibirInsta: insta,
        exibirTrip: trip,
        exibirWhatsApp: zap,
        urlGoogle: googleUrl,
        urlTrip: tripUrl,
        urlInsta: instaUrl,
        urlWhats: zpUrl,
        critica: txtCritica,
        elogio: txtElogio,
        textoInsta: txtInsta,
        textoZap: txtZap,
        redes: redes,
      });
    }
  }

  handleInsta() {
    window.open(this.state.urlInsta, '_blank');
  }

  handleWhatsApp() {
    window.open(this.state.urlWhats, '_blank');
  }

  handleChangeFilial = async () => {
    await this.service.listFilial();
  };

  getQuestionsFilial = async () => {
    const data = this.props.questionsFilial.perguntas;

    const racionais =
      data &&
      data.filter(_racionais => {
        return _racionais.idSegmentoPergunta === 1;
      });

    const emocionais =
      data &&
      data.filter(_emocionais => {
        return _emocionais.idSegmentoPergunta === 2;
      });

    const nps =
      data &&
      data.filter(nps => {
        return nps.idSegmentoPergunta === 3;
      });

    const criticas =
      data &&
      data.filter(criticas => {
        return criticas.idSegmentoPergunta === 4;
      });

    const outros =
      data &&
      data.filter(criticas => {
        return criticas.idSegmentoPergunta === 5;
      });

    const elogios =
      data &&
      data.filter(elogios => {
        return elogios.descricao === 'Crítica';
      });

    this.setState({
      dataQuestions: data,
      emocionais,
      racionais,
      outros,
      nps,
      criticas,
      elogios,
    });
  };

  next() {
    const current = this.state.current + 1;

    this.setState({ current });
  }

  prev() {
    const current = this.state.current - 1;
    this.setState({ current });
  }

  changeRate = async (data, ask, index) => {
    const { rateValue } = this.state;
    rateValue[index] = data;
    this.setState({ rateValue });

    if (data <= 3) {
      this.setState({ subPerguntas: ask.subPergunta });
    } else {
      this.setState({ subPerguntas: 5 });
    }

    let arrResponse = [];
    arrResponse = this.state.arrResponse;
    let currentResponse = this.state.arrResponse
      .filter(item => item.idPergunta === ask.id)
      .shift();

    if (currentResponse) {
      currentResponse.valorInteiro = data;
      arrResponse[arrResponse.indexOf(currentResponse)] = currentResponse;
    } else {
      arrResponse.push(this.parseResponse(data, 'int', ask));
    }
    await this.setState({ arrResponse });
  };

  changeIndiceBlue = async (data, ask) => {
    let arrResponse = [];
    arrResponse = this.state.arrResponse;
    let currentResponse = this.state.arrResponse
      .filter(item => item.idPergunta === ask.id)
      .shift();
    if (currentResponse) {
      currentResponse.valorInteiro = data;
      arrResponse[arrResponse.indexOf(currentResponse)] = currentResponse;
    } else {
      arrResponse.push(this.parseResponse(data, 'int', ask));
    }
    await this.setState({ arrResponse, indice_blue: data });
  };

  changeText = async (data, ask) => {
    let arrResponse = [];
    arrResponse = this.state.arrResponse;
    let currentResponse = this.state.arrResponse
      .filter(item => item.idPergunta === ask.id)
      .shift();

    if (currentResponse) {
      currentResponse.valorChar = data;
      arrResponse[arrResponse.indexOf(currentResponse)] = currentResponse;
    } else {
      arrResponse.push(this.parseResponse(data, 'char', ask));
    }
    await this.setState({ arrResponse });
  };

  changeTextCritica = async (data, ask) => {
    let arrResponse = [];
    arrResponse = this.state.arrResponse;
    let currentResponse = this.state.arrResponse
      .filter(item => item.idPergunta === ask.id)
      .shift();

    if (currentResponse) {
      currentResponse.valorChar = data;
      arrResponse[arrResponse.indexOf(currentResponse)] = currentResponse;
    } else {
      arrResponse.push(this.parseResponse(data, 'char', ask));
    }
    await this.setState({ arrResponse });
  };

  changeBool = async (data, ask) => {
    let arrResponse = [];
    arrResponse = this.state.arrResponse;
    let currentResponse = this.state.arrResponse
      .filter(item => item.idPergunta === ask.id)
      .shift();

    if (currentResponse) {
      currentResponse.valorBoolean = data;
      arrResponse[arrResponse.indexOf(currentResponse)] = currentResponse;
    } else {
      arrResponse.push(this.parseResponse(data, 'bool', ask));
    }
    await this.setState({ arrResponse });
  };

  changeSubAsk = async (data, ask) => {
    let arrResponse = this.state.arrResponse;
    let indexToRemove = arrResponse.findIndex(
      item => item.idSubPergunta === ask.id
    );
    if (indexToRemove >= 0) {
      arrResponse.splice(indexToRemove, 1);
    } else {
      arrResponse.push(this.parseSubResponse(ask.ativa, 'bool', ask));
    }
    await this.setState({ arrResponse });
  };

  changeRadio = (id, data) => {
    let arrResponse = [...this.state.arrResponse];

    const newData = {
      pId: id,
      id: data.id,
    };

    arrResponse = arrResponse.filter(item => item.idPergunta !== id);

    arrResponse.push(this.parseSubResponseV2(data.ativa, 'bool', newData));
    this.setState({ arrResponse });
  };

  getValue(ask, type) {
    let currentResponse = this.state.arrResponse
      .filter(item => item.idPergunta === ask.id)
      .shift();

    if (currentResponse) {
      return type === 'int'
        ? currentResponse.valorInteiro
        : type === 'char'
          ? currentResponse.valorChar
          : currentResponse.valorBoolean;
    }
    return '';
  }

  getValueCritica(ask, type) {
    let currentResponse = this.state.arrResponse
      .filter(item => item.idPergunta === ask.id)
      .shift();

    if (currentResponse) {
      return type === 'int'
        ? currentResponse.valorInteiro
        : type === 'char'
          ? currentResponse.valorChar
          : currentResponse.valorBoolean;
    }
    return '';
  }

  parseResponse(data, type, ask) {
    let _payload = {
      idPergunta: ask.id,
    };
    _payload[
      type === 'int'
        ? 'valorInteiro'
        : type === 'char'
          ? 'valorChar'
          : 'valorBoolean'
    ] = data;
    return _payload;
  }

  parseSubResponse(data, type, ask) {
    let _payload = {
      idSubPergunta: ask.id,
    };
    _payload[
      type === 'int'
        ? 'valorInteiro'
        : type === 'char'
          ? 'valorChar'
          : 'valorBoolean'
    ] = data;
    return _payload;
  }

  parseSubResponseV2(data, type, ask) {
    let _payload = {
      idSubPergunta: ask.id,
      idPergunta: ask.pId,
    };
    _payload[
      type === 'int'
        ? 'valorInteiro'
        : type === 'char'
          ? 'valorChar'
          : 'valorBoolean'
    ] = data;
    return _payload;
  }

  generateFeedbackText = () => {
    const responseElogio = this.state.arrResponse.find(
      r => r.idPergunta === 86
    );
    const responseCritica = this.state.arrResponse.find(
      r => r.idPergunta === 87
    );
    const elogio = responseElogio ? responseElogio.valorChar : '';
    const critica = responseCritica ? responseCritica.valorChar : '';

    return `${elogio} ${critica}`.trim();
  };

  startCountdownRedirect = (segundos) => {
    if (this.toastInterval) {
      clearInterval(this.toastInterval);
    }
    this.setState({
      showModal: true,
      countdownValue: segundos,
      modalMessage: `Abrindo o Google em ${segundos}...`,
    });

    this.toastInterval = setInterval(() => {
      this.setState(prevState => {
        const novoValor = prevState.countdownValue - 1;

        if (novoValor <= 0) {
          clearInterval(this.toastInterval);

          window.location.href = this.state.urlGoogle;
          return { showModal: false };
        }

        return {
          countdownValue: novoValor,
          modalMessage: `Abrindo o Google em ${novoValor}...`,
        };
      });
    }, 1000);
  };

  redirectToGoogle = (segundos = 5) => {

    const texto = this.generateFeedbackText()
    const mensagemPadrao = ' ';
    const conteudo = texto || mensagemPadrao;

    navigator.clipboard.writeText(conteudo)
      .then(() => {
        this.startCountdownRedirect(segundos);
      })
      .catch((err) => {
        console.error('Erro ao copiar para a área de transferência:', err);
        this.startCountdownRedirect(segundos);
      });
  };


  validateForm = () => {
    if (!this.state.identificacaoObrigatoria) return true;

    const { nome, email, celular } = this.state;
    let celularNum = celular ? celular.replace(/\D/g, '') : '';
    let valid = true;

    if (!nome || nome.length < 3) {
      message.warn('Informe o seu nome.');
      valid = false;
    }

    if (!email || !validaEmail(email)) {
      message.warn('Informe o seu e-mail.');
      valid = false;
    }

    if (!celularNum || celularNum.length < 8) {
      message.warn('Informe o seu telefone.');
      valid = false;
    }

    return valid;
  };

  onChangeForm = async () => {
    const texto = this.generateFeedbackText()
    const mensagemPadrao = 'Adorei a experiência. Recomendo!';
    const conteudo = texto || mensagemPadrao;
    navigator.clipboard.writeText(conteudo)

    this.setState({ loading: true });

    if (!this.validateForm()) {
      this.setState({ loading: false });
      return;
    }

    // 2. Montagem do payload
    const payload = {
      idFilial: this.state.idFilial,
      nome: this.state.nome,
      celular: this.state.celular,
      email: this.state.email,
      indiceBlue: 0,
      nps: 0,
      dataRespostas: new Date(),
      verificado: true,
      respostas: this.state.arrResponse,
    };

    try {
      // 3. Chamada API
      const retorno = await this.service.postQuestionsAnswers(payload);
      this.setState({ loading: false });

      if (!retorno.object.ok) {
        message.error(retorno.mensage || 'Falha ao responder! Tente novamente.');
        return;
      }

      // 4. Sucesso
      message.success('Avaliação registrada com sucesso!');
      this.saveValueLocalStorage(this.state.idEmpresa, this.state.idFilial, true);

      const googleLogic = async () => {
        const resultGoogle = await this.service.getIdentificacaoObrigatoria(this.state.idFilial);
        const redirecionamentoGoogleV2 = resultGoogle.object.redirecionamentoGoogle
        const redes = this.state.redes
        const goo = redes.filter(x => x.tipo === 'Google');

        const nota = this.state.indice_blue;

        const critica = this.state.arrResponse.filter(x => x.idPergunta === 87);

        if (redirecionamentoGoogleV2) {
          if (
            goo[0].exibirParaCriticas &&
            critica &&
            critica.length > 0 &&
            critica[0].valorChar
          ) {
            return false;
          }

          if (goo[0].exibirApenasPromotores && nota >= 9) {
            return true;
          }

          if (goo[0].exibirPromotoresNeutros && nota >= 7) {
            return true;
          }

          if (goo[0].exibirParaTodas) {
            return true;
          }

          if (goo[0].exibirParaCriticas) {
            return false;
          }
        }

        return false;
      };


      const redirectToGoogleV2 = await googleLogic()

      if (redirectToGoogleV2) {
        try {
          this.redirectToGoogle();
        } catch (error) {
          this.startCountdownRedirect(5);

        }
      } else {
        let urlObrigado = `/blue/questionario/${this.state.idEmpresa}/${this.state.idFilial}/obrigado`;
        if (retorno.object.beneficioVoucher) {
          urlObrigado += `/${retorno.object.beneficioVoucher}`;
        }

        setTimeout(() => {
          this.props.history.push(urlObrigado, {
            nota: this.state.indice_blue,
            response: this.state.arrResponse,
          });
        }, 10);
      }
    } catch (err) {
      this.setState({ loading: false });
      message.error('Erro inesperado. Tente novamente.');
      console.error(err);
    } finally {
      this.setState({ loading: false });
    }
  };


  onChangeCheck(checkedValues) {
    this.setState({
      ...this.state.checkSubPerguntas,
      checkSubPerguntas: checkedValues.target.value,
    });
  }

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({
          loading: true,
          email: values.email,
          celular: values.celular,
        });
        this.onChangeForm();
      }
    });
  };

  saveValueLocalStorage(idEmpresa, idFilial, valor) {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 7);

    const expires = expirationDate.toUTCString();

    const cookieValue = `${idEmpresa}:${idFilial}=${JSON.stringify(
      valor
    )};expires=${expires};path=/`;

    document.cookie = cookieValue;
  }

  getNomeFilial(nome) {
    return this.state.unidadeSemNome ? '' : `(${nome})`;
  }

  carregarLogo = async (idEmpresa, idFilial) => {
  };

  carregarTipoExibicao = async idEmpresa => {
    let tipo = 1;
    const result = await consultarTipoExibicao(idEmpresa);
    if (result) {
      tipo = result.object;
    }
    this.setState({
      tipoExibicaoQuesito: tipo,
    });
  };

  carregarIdentificacaoObrigatoria = async idFilial => {
    const result = await this.service.getIdentificacaoObrigatoria(idFilial);

    this.setState({
      identificacaoObrigatoria: result.object.identificacaoObrigatoria,
      redirecionamentoGoogle: result.object.redirecionamentoGoogle,
    });
  };

  getValueLocalStorage(idEmpresa, idFilial) {
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();

      if (cookie.startsWith(`${idEmpresa}:${idFilial}=`)) {
        const cookieValue = cookie.substring(
          `${idEmpresa}:${idFilial}=`.length,
          cookie.length
        );

        return JSON.parse(decodeURIComponent(cookieValue));
      }
    }

    return null;
  }

  getRespostaUnica() {
    const { idEmpresa, idFilial } = this.props.match.params;

    const respostaFilial = this.getValueLocalStorage(idEmpresa, idFilial);

    this.setState({
      respostaUnica: respostaFilial,
    });
  }

  render() {
    const { current } = this.state;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8, offset: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16, offset: 4 },
      },
    };

    let company = 'esta empresa';
    if (this.props.questionsFilial.filial) {
      company =
        `${this.props.questionsFilial.filial.nomeEmpresa} ` +
        this.getNomeFilial(this.props.questionsFilial.filial.nome);
    }

    const getStateKey = () => {
      const stateKey = ['nps', 'racionais', 'emocionais'];

      const nps = this.state.nps && this.state.nps.length > 0;
      const racionais =
        this.state.tipoExibicaoQuesito === 1 ||
        this.state.tipoExibicaoQuesito === 2;
      const emocionais =
        this.state.tipoExibicaoQuesito === 1 ||
        this.state.tipoExibicaoQuesito === 3;
      const outros = this.state.outros && this.state.outros.length > 0;

      if (!nps) {
        stateKey.splice(stateKey.indexOf('nps'), 1);
      }

      if (!racionais) {
        stateKey.splice(stateKey.indexOf('racionais'), 1);
      }

      if (!emocionais) {
        stateKey.splice(stateKey.indexOf('emocionais'), 1);
      }

      if (outros) {
        stateKey.push('outros');
      }

      return stateKey;
    };

    let steps = [
      {
        title: `De 0 a 10, o quanto você recomendaria <strong>${company}</strong> para um amigo?`,
        show: true,
        question1: (
          <Row style={{ marginTop: 20, marginBottom: 10 }}>
            <Col span={22} offset={1}>
              <div className="indice-blue">
                {arr.map((i, key) => {
                  return (
                    <div
                      key={key}
                      className={
                        this.state.indice_blue === key
                          ? 'indice-blue-item selected'
                          : 'indice-blue-item'
                      }
                      onClick={() => this.changeIndiceBlue(key, { id: 85 })}
                    >
                      {key}
                    </div>
                  );
                })}
              </div>
            </Col>
          </Row>
        ),
        question2: (
          <Row style={{ marginBottom: 50 }}>
            <Col span={22} offset={1}>
              <p style={{ marginTop: 25, marginBottom: 0, fontSize: 16 }}>
                Caso tenha algum motivo específico para ter dado essa nota,
                conta pra gente.
              </p>
            </Col>
          </Row>
        ),
        question3: (
          <Row>
            <Row>
              <Col span={4}>
                <Icon
                  type="like"
                  style={{ fontSize: 30, color: 'green', marginTop: 15 }}
                />
              </Col>
              <Col style={{ marginBottom: 10 }} span={18}>
                <TextArea
                  rows={3}
                  placeholder="Elogios / Sugestões / Comentários"
                  onChange={e => this.changeText(e.target.value, { id: 86 })}
                  value={this.getValue({ id: 86 }, 'char')}
                />
              </Col>
            </Row>
            <Row>
              <Col span={4}>
                <Icon
                  type="dislike"
                  style={{ fontSize: 30, marginTop: 15, color: 'red' }}
                />
              </Col>
              <Col span={18}>
                <TextArea
                  rows={3}
                  placeholder="Críticas / Reclamações"
                  onChange={e =>
                    this.changeTextCritica(e.target.value, { id: 87 })
                  }
                  value={this.getValueCritica({ id: 87 }, 'char')}
                />
              </Col>
            </Row>
          </Row>
        ),
        question4: 'Image2 Input2',
      },
      {
        title: 'Qual o seu grau de <strong>satisfação</strong> sobre:',
        show:
          this.state.tipoExibicaoQuesito === 1 ||
          this.state.tipoExibicaoQuesito === 2,
        question1: (
          <div>
            {this.state.racionais &&
              this.state.racionais.map(item => {
                return (
                  <div key={item.id}>
                    <h3>{item.descricao}</h3>
                    <div style={{ marginBottom: 30 }}>
                      <RateComponent
                        changeSubAsk={this.changeSubAsk.bind(this)}
                        changeRate={this.changeRate.bind(this)}
                        item={item}
                        arrResponse={this.state.arrResponse}
                      />
                    </div>
                  </div>
                );
              })}
          </div>
        ),
      },
      {
        title: 'Qual o seu grau de <strong>felicidade</strong> sobre:',
        show:
          this.state.tipoExibicaoQuesito === 1 ||
          this.state.tipoExibicaoQuesito === 3,
        question1: (
          <div>
            {this.state.emocionais &&
              this.state.emocionais.map(item => {
                return (
                  <div key={item.id}>
                    <h3>{item.descricao}</h3>
                    <div style={{ marginBottom: 30 }}>
                      <RateComponent
                        changeSubAsk={this.changeSubAsk.bind(this)}
                        state={this.state}
                        changeRate={this.changeRate.bind(this)}
                        item={item}
                        arrResponse={this.state.arrResponse}
                      />
                    </div>
                  </div>
                );
              })}
          </div>
        ),
      },
      {
        title: 'Para finalizar...',
        show: true,
        question1: (
          <div>
            <Row>
              {this.props.questionsFilial &&
                this.props.questionsFilial.beneficio ? (
                <Col>
                  <p
                    style={{
                      fontSize: '11pt',
                      marginTop: 20,
                      marginBottom: 0,
                      fontWeight: 'lighter',
                    }}
                  >
                    Precisamos saber para quem estamos enviando o prêmio.
                  </p>
                  {!this.state.identificacaoObrigatoria && (
                    <p style={{ fontSize: '11pt', marginTop: 0 }}>
                      (É opcional, mas o cupom só será gerado se você preencher
                      seus dados válidos)
                    </p>
                  )}
                </Col>
              ) : (
                <>
                  {!this.state.identificacaoObrigatoria && (
                    <Col>
                      <h4>
                        É opcional, mas gostamos de saber quem nos ajudou.
                      </h4>
                    </Col>
                  )}
                </>
              )}
              <Col
                span={20}
                offset={2}
                style={{ marginBottom: 10, marginTop: 20 }}
              >
                <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                  <Form.Item>
                    <Input
                      placeholder={'Nome'}
                      prefix={
                        <Icon
                          type="user"
                          style={{ color: 'rgba(0,0,0,.25)' }}
                        />
                      }
                      onChange={e => {
                        this.setState({ nome: e.target.value });
                      }}
                    />
                  </Form.Item>
                  <Form.Item>
                    <Input
                      placeholder="E-mail"
                      type="email"
                      prefix={
                        <Icon
                          type="mail"
                          style={{ color: 'rgba(0,0,0,.25)' }}
                        />
                      }
                      onChange={e => {
                        this.setState({ email: e.target.value });
                      }}
                    />
                  </Form.Item>
                  <Form.Item>
                    <span className="ant-input-affix-wrapper">
                      <span className="ant-input-prefix">
                        <Icon
                          type="phone"
                          style={{ color: 'rgba(0,0,0,.25)' }}
                        />
                      </span>
                      <InputMask
                        className="ant-input"
                        mask="(99) 99999-9999"
                        placeholder="Celular"
                        onChange={e => {
                          this.setState({ celular: e.target.value });
                        }}
                      />
                    </span>
                  </Form.Item>
                </Form>
              </Col>
            </Row>

            {this.state.outros &&
              this.state.outros.map(item => {
                return (
                  <div key={item.id}>
                    <h3>{item.descricao}</h3>
                    <div style={{ marginBottom: 30 }}>
                      <RateComponent
                        changeSubAsk={data =>
                          this.changeRadio(
                            item.id,
                            item.subPergunta.find(sub => sub.id === data)
                          )
                        }
                        state={this.state}
                        changeRate={this.changeRate.bind(this)}
                        item={item}
                        arrResponse={this.state.arrResponse}
                        multiSelect
                      />
                    </div>
                  </div>
                );
              })}

            <Row
              style={{
                fontWeight: 'lighter',
                color: '#003060',
                fontSize: '10pt',
                padding: 8,
              }}
            >
              Não se preocupe! Seus dados estarão em sigilo e segurança. Caso
              você concorde e escolha informá-los, eles podem ser usados para
              nos ajudar a melhorar a sua experiência ou para comunicação.
              <br />
              <a
                target="_blank"
                href="https://blueexperiencias.com.br/politicas-privacidade"
                style={{ textDecoration: 'underline' }}
              >
                (Políticas de Privacidade)
              </a>
              {this.props.questionsFilial.beneficio && (
                <>
                  {this.props.questionsFilial.beneficio
                    .tempoProximoPremioMesmoEmailDias > 0 ? (
                    <></>
                  ) : (
                    <p>
                      É possível gerar <strong>1 cupom por e-mail</strong>.
                    </p>
                  )}
                </>
              )}
            </Row>
          </div>
        ),
      },
    ];

    steps = steps.filter(x => x.show);

    let stepComplete = false;

    let stageToKey = getStateKey();

    var key = stageToKey[this.state.current];
    if (key === 'racionais' && this.state.tipoExibicaoQuesito === 3) {
      key = 'emocionais';
    } else if (key === 'emocionais' && this.state.tipoExibicaoQuesito === 2) {
      key = 'racionais';
    } else if (key === 'outros' && this.state.tipoExibicaoQuesito === 5) {
      key = 'outros';
    }
    let questions = this.state[key];

    var answered = 0;

    if (questions != undefined) {
      for (var i = 0; i < questions.length; i++) {
        for (var i2 = 0; i2 < this.state.arrResponse.length; i2++) {
          let response = this.state.arrResponse[i2];
          if (
            questions[i].id == response.idPergunta &&
            (response.valorInteiro > 0 || key == 'nps')
          ) {
            answered++;
            continue;
          }

          if (key == 'outros' && questions[i].id == response.idPergunta) {
            answered++;
            break;
          }
        }
      }

      if (questions == undefined) {
        stepComplete = true;
      }

      stepComplete = answered >= questions.length;
    }

    if (questions == undefined) {
      stepComplete = true;
    }

    if (stageToKey.length == 1 && questions == undefined) {
      stepComplete = true;
    }

    return !this.state.respostaUnica ? (
      <Layout>
        <Content
          style={{
            padding: '24px 16px 0',
            height: '90vh',
            backgroundColor: '#FFF',
          }}
        >
          <Row
            style={{
              flexDirection: 'row',
              textAlign: 'center',
              margin: '24px 16px 0',
            }}
          >
            <Col
              xs={{ span: 24 }}
              md={{ span: 10, offset: 8 }}
              lg={{ span: 10, offset: 8 }}
            >
              <Steps
                style={{
                  textAlign: 'center',
                  margin: 'auto',
                }}
                current={current}
                size="small"
              >
                {steps.map((item, key) => (
                  <Step key={key} />
                ))}
              </Steps>
              <div className="steps-content">
                <div style={{ margin: 8 }}>
                  <h2
                    style={{ marginBottom: 30 }}
                    dangerouslySetInnerHTML={{
                      __html: steps[current] ? steps[current].title : '',
                    }}
                  ></h2>
                </div>
                <div>
                  <h4>{steps[current].question1}</h4>
                </div>
                <div>
                  <h4>{steps[current].question2}</h4>
                </div>
                <div>
                  <h4>{steps[current].question3}</h4>
                </div>
              </div>
              <div className="steps-action">
                {this.state.showButton && current > 0 && (
                  <Button
                    style={{ marginRight: 10 }}
                    onClick={() => this.prev()}
                  >
                    Voltar
                  </Button>
                )}
                {this.state.showButton &&
                  current === steps.filter(x => x.show).length - 1 && (
                    <Button
                      type="secondary"
                      loading={this.state.loading}
                      onClick={() => this.onChangeForm()}
                      disabled={!stepComplete || this.state.loading}
                    >
                      Concluir
                    </Button>
                  )}
                {this.state.showButton && current < steps.length - 1 && (
                  <Button
                    className="next-step"
                    type="secondary"
                    onClick={() => this.next()}
                    disabled={!stepComplete}
                  >
                    Próximo
                  </Button>
                )}
              </div>
            </Col>
          </Row>
          <Modal
            closable={false}
            visible={this.state.showModal}
            footer={null}
            centered
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                maxWidth: 400,
                margin: '0 auto',
              }}
            >
              <div
                style={{
                  fontSize: '28px',
                  fontWeight: '600',
                  color: '#444',
                  marginBottom: '20px',
                  width: '100%',
                }}
              >
                QUASE LÁ...
              </div>

              <div
                style={{
                  fontSize: '16px',
                  color: '#444',

                  marginBottom: '20px',
                }}
              >
                Com <strong>1 clique</strong>, compartilhe sua experiência. 💙
              </div>

              <div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: 2,
                    marginBottom: '20px',
                    width: '100%',
                  }}
                >
                  <span
                    style={{
                      fontSize: '14px',
                      color: '#444',
                      display: 'block',
                    }}
                  >
                    ✅ Sua opinião já foi copiada.
                  </span>
                  <span
                    style={{
                      fontSize: '14px',
                      color: '#444',
                      display: 'block',
                    }}
                  >
                    ✅ Agora, basta colar e postar no Google.
                  </span>
                </div>
              </div>

              <img
                src="/loading.gif"
                alt="Carregando"
                style={{
                  width: '48px',
                  height: '48px',
                  marginBottom: '8px',
                }}
              />

              <div
                style={{
                  fontSize: '13px',
                  color: '#888',
                  marginBottom: '10px',
                }}
              >
                {this.state.modalMessage}
              </div>
            </div>
          </Modal>
        </Content>
      </Layout>
    ) : (
      <Layout>
        <Content
          style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: '100px',
            backgroundColor: '#FFF',
          }}
        >
          {this.state.logoCliente && (
            <Row
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img src={this.state.logoCliente} class="logo-cliente" />
            </Row>
          )}

          <Row>
            <p style={{ fontSize: '22pt', textAlign: 'center' }}>
              <strong>Obrigado!</strong> <br></br> Você já fez esta avaliação
              recentemente.
            </p>
          </Row>

          {this.state.temRedeSocial && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'start',
                width: '100%',
                paddingLeft: '10%',
              }}
            >
              <Button
                onClick={() => this.handleInsta()}
                className="btn-rede-social follow-us"
              >
                <img src={btnInsta} alt="Siga a gente no instagram" />
                <label>{this.state.textoInsta}</label>
              </Button>
              <Button
                onClick={() => this.handleWhatsApp()}
                className="btn-rede-social follow-us"
              >
                <img src={btnZap} alt="Fale com a gente no whatsapp" />
                <label>{this.state.textoZap}</label>
              </Button>
            </div>
          )}
        </Content>
      </Layout>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { getUserData, getDataUserCompany, getModalTrue },
    dispatch
  );

const mapStateToProps = store => ({
  userData: store.userData.data,
  dataUserCompany: store.userData.dataUserCompany,
  clientFilial: store.userData.clientFilial,
  filialId: store.userData.filialId,
  questionsFilial: store.userData.questionsFilial,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(QuizSteps));
